import { fmt } from "@/lib/writing";
import { PagedFrame } from "@/components/Paged";

const Note = ({ label, html, testId }) => (
  <aside className="pt-note my-8 ml-4 rounded-xl border-l-2 border-amber-500/40 bg-veil/[0.02] px-5 py-3" data-testid={testId}>
    <p className="pt-note-label text-[11px] italic text-slate-500 mb-1">{label}</p>
    <div className="note-prose" dangerouslySetInnerHTML={{ __html: html }} />
  </aside>
);

export const ChapterBody = ({ c }) => (<>
  {c.begin_note && <Note label="Beginning note" html={c.begin_note} testId={`full-begin-note-${c.id}`} />}
  {c.html ? <div className="writing-prose" dangerouslySetInnerHTML={{ __html: c.html }} /> : <p className="text-center text-slate-500 italic">Nothing written yet.</p>}
  {c.end_note && <Note label="End note" html={c.end_note} testId={`full-end-note-${c.id}`} />}
</>);

// All chapters as one document; clicking a chapter header jumps to it in the Write tab
export const FullWork = ({ work, chapters, onJump, counts = {}, onCount }) => {
  let page = 1;
  const openLinks = (e) => {
    const a = e.target.closest("a[href]");
    if (a) { e.preventDefault(); window.open(a.getAttribute("href"), "_blank", "noopener"); }
  };
  return (
    <article className={`mx-auto py-14 ${work.paged ? "px-0" : "w-full px-6 sm:px-10 lg:px-16"}`} onClick={openLinks} data-testid="full-work">
      <header className="text-center mb-16">
        <h1 className="font-display text-4xl sm:text-5xl text-amber-50">{work.title}</h1>
        {work.summary && <p className="mt-4 text-slate-400 italic">{work.summary}</p>}
        <p className="mt-4 font-code text-[11px] text-slate-500">{chapters.length} {chapters.length === 1 ? "chapter" : "chapters"} · {fmt(chapters.reduce((n, c) => n + c.words, 0))} words</p>
      </header>
      {chapters.map((c, i) => {
        const start = page;
        page += counts[c.id] || 1;
        const body = (<>
          <button onClick={() => onJump(c.id)} className="group w-full text-center mb-8" title="Edit this chapter" data-testid={`full-chapter-jump-${c.id}`}>
            <span className="pt-kicker block font-code text-[10px] uppercase tracking-[0.3em] text-amber-500/70">Chapter {i + 1}</span>
            <span className="pt-title block font-display text-3xl text-amber-100 group-hover:text-amber-300 transition-colors mt-1">{c.title}</span>
          </button>
          <ChapterBody c={c} />
        </>);
        return <section key={c.id} className="mb-16" data-testid={`full-chapter-${c.id}`}>
          {work.paged ? <PagedFrame size={work.page_size} startPage={start} onPages={(n) => onCount?.(c.id, n)}>{body}</PagedFrame> : body}
        </section>;
      })}
    </article>
  );
};
